// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .overlay {
    position:fixed;
    display:block;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background-color: #000000;
    z-index: 99999;
    opacity: .8;
  }
  
  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    color: #fff;
    transform: translate(-50%,-50%);
    z-index: 999999;
    border: 5px solid #009BBF;
    width: 130px;
    border-radius: 10px;
} */



.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .spinner {
  width: 60px;
  height: 60px;
  border: 6px solid rgba(255, 0, 0, 0.4);
  border-top-color: red;
  border-radius: 50%;
  animation: spin 1s linear infinite;
} */

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}





.lds-ripple,
.lds-ripple div {
  box-sizing: border-box;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid red;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/loader/loader.component.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;;;AAIH;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;;;GAOG;;AAEH;EACE;IACE,yBAAyB;EAC3B;AACF;;;;;;AAMA;;EAEE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,8DAA8D;AAChE;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,UAAU;EACZ;EACA;IACE,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF","sourcesContent":["/* .overlay {\n    position:fixed;\n    display:block;\n    width:100%;\n    height:100%;\n    top:0;\n    left:0;\n    background-color: #000000;\n    z-index: 99999;\n    opacity: .8;\n  }\n  \n  .spinner {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    color: #fff;\n    transform: translate(-50%,-50%);\n    z-index: 999999;\n    border: 5px solid #009BBF;\n    width: 130px;\n    border-radius: 10px;\n} */\n\n\n\n.overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 50;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* .spinner {\n  width: 60px;\n  height: 60px;\n  border: 6px solid rgba(255, 0, 0, 0.4);\n  border-top-color: red;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n} */\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n\n\n.lds-ripple,\n.lds-ripple div {\n  box-sizing: border-box;\n}\n.lds-ripple {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.lds-ripple div {\n  position: absolute;\n  border: 4px solid red;\n  opacity: 1;\n  border-radius: 50%;\n  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.lds-ripple div:nth-child(2) {\n  animation-delay: -0.5s;\n}\n@keyframes lds-ripple {\n  0% {\n    top: 36px;\n    left: 36px;\n    width: 8px;\n    height: 8px;\n    opacity: 0;\n  }\n  4.9% {\n    top: 36px;\n    left: 36px;\n    width: 8px;\n    height: 8px;\n    opacity: 0;\n  }\n  5% {\n    top: 36px;\n    left: 36px;\n    width: 8px;\n    height: 8px;\n    opacity: 1;\n  }\n  100% {\n    top: 0;\n    left: 0;\n    width: 80px;\n    height: 80px;\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
